import React, {useState, useEffect, useMemo} from 'react';
import { observer } from 'mobx-react'
import './index.css';
import GlobalState from "../../../stores/GlobalState";
import lang from "../../../lang"
import {Bar} from "react-chartjs-2"
import {Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend, layouts, scales} from 'chart.js'
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const Contop = observer(({ lower, upper }) => {
    var i1 = 0;
    const [langmenu, setLangmenu] = useState(localStorage.getItem("lang_site")||"en")
    const [langv, setLangv]= useState(langmenu=="de"?lang.de:lang.en)

    // ===== Double-threshold adapter (беремо дані з metadata.doubleThresholdsData по lower/upper) =====
    const doubleThresholdsData = GlobalState.activemodel?.lastTrain?.metadata?.doubleThresholdsData || [];

    const selectedDouble = useMemo(() => {
        if (!doubleThresholdsData?.length) return null;

        const roundToStep = (v, step = 0.05) => Math.round(v / step) * step;
        const sameStep = (a, b, step = 0.05) => Math.abs(roundToStep(a, step) - roundToStep(b, step)) < 1e-9;

        const l = roundToStep(Number(lower), 0.05);
        const u = roundToStep(Number(upper), 0.05);

        return doubleThresholdsData.find((o) => sameStep(o.lowerThreshold, l) && sameStep(o.upperThreshold, u)) || null;
    }, [doubleThresholdsData, lower, upper]);

    // Будуємо "старий" формат metrics.targets[0/1] з нового selectedDouble, щоб нижче майже нічого не ламати
    const metrics = useMemo(() => {
        if (!selectedDouble) {
            return {
                targets: [
                    { target: "0", precision: 0, recall: 0, f1Score: 0, confusionMatrix: { tp: 0, fp: 0, fn: 0, tn: 0, positivesTotal: 0, negativesTotal: 0, truePositivesPercentage: 0, trueNegativesPercentage: 0, falsePositivesPercentage: 0, falseNegativesPercentage: 0 } },
                    { target: "1", precision: 0, recall: 0, f1Score: 0, confusionMatrix: { tp: 0, fp: 0, fn: 0, tn: 0, positivesTotal: 0, negativesTotal: 0, truePositivesPercentage: 0, trueNegativesPercentage: 0, falsePositivesPercentage: 0, falseNegativesPercentage: 0 } },
                ],
                accuracy: 0,
            };
        }

        const cm = selectedDouble.confusionMatrix || [[0,0],[0,0]];
        const tn = cm?.[0]?.[0] ?? 0;
        const fp = cm?.[0]?.[1] ?? 0;
        const fn = cm?.[1]?.[0] ?? 0;
        const tp = cm?.[1]?.[1] ?? 0;

        const positivesTotal = tp + fn;
        const negativesTotal = tn + fp;

        const safeDiv = (a, b) => (b ? a / b : 0);

        // Для target 1: TP/FP/FN/TN як є
        const cm1 = {
            tp, fp, fn, tn,
            positivesTotal,
            negativesTotal,
            truePositivesPercentage: safeDiv(tp, positivesTotal),
            trueNegativesPercentage: safeDiv(tn, negativesTotal),
            falsePositivesPercentage: safeDiv(fp, negativesTotal),
            falseNegativesPercentage: safeDiv(fn, positivesTotal),
        };

        // Для target 0: дзеркально (як у твоєму старому metrics.targets[0] vs [1])
        const cm0 = {
            tp: tn,
            fp: fn,
            fn: fp,
            tn: tp,
            positivesTotal: negativesTotal,
            negativesTotal: positivesTotal,
            truePositivesPercentage: safeDiv(tn, negativesTotal),
            trueNegativesPercentage: safeDiv(tp, positivesTotal),
            falsePositivesPercentage: safeDiv(fn, positivesTotal),
            falseNegativesPercentage: safeDiv(fp, negativesTotal),
        };

        return {
            targets: [
                {
                    target: "0",
                    precision: selectedDouble.precision0 ?? 0,
                    recall: selectedDouble.recall0 ?? 0,
                    f1Score: selectedDouble.f1Score0 ?? 0,
                    confusionMatrix: cm0,
                },
                {
                    target: "1",
                    precision: selectedDouble.precision1 ?? 0,
                    recall: selectedDouble.recall1 ?? 0,
                    f1Score: selectedDouble.f1Score1 ?? 0,
                    confusionMatrix: cm1,
                },
            ],
            accuracy: selectedDouble.accuracy ?? 0,
            nSelected: selectedDouble.nSelected ?? 0,
            selectedRatio: selectedDouble.selectedRatio ?? 0,
            unselected0: selectedDouble.unselected0 ?? 0,
            unselected1: selectedDouble.unselected1 ?? 0,
        };
    }, [selectedDouble]);

    // topFields у старому коді очікувався як об'єкт {fieldName: importance}
// У doubleThresholdsData часто topFields не приходить, тому робимо fallback на metadata.topFields (як було раніше)
const topFieldsObj = useMemo(() => {
    // 1) якщо в selectedDouble є topFields (масив) — використовуємо його
    const arr = selectedDouble?.topFields;
    if (Array.isArray(arr) && arr.length) {
        const obj = {};
        arr.forEach((x) => {
            if (x?.fieldName != null) obj[x.fieldName] = x.importance ?? 0;
        });
        return obj;
    }

    // 2) fallback: старий формат — вже готовий об'єкт у metadata.topFields
    const oldObj = GlobalState.activemodel?.lastTrain?.metadata?.topFields;
    if (oldObj && typeof oldObj === "object" && !Array.isArray(oldObj)) {
        return oldObj;
    }

    return {};
}, [selectedDouble, GlobalState.activemodel]);
    // =================================================================================================
    console.log(lower)
    var coef = 1;
    var first = 0;
    var flag = 0;
    var last = 0;
    var otstup = "- "+((metrics?.targets.length-1)*8)+"px";
    var otstup2 = "- "+((metrics?.targets.length-1) - 4)+"px";
    console.log(otstup)
    Object.entries(topFieldsObj||[]).sort(([,a],[,b]) => a-b).reverse().slice(0,10).map(([key, value])=>
        flag==0?
        <>
            {
                first=value
            }
            {
                last=value
            }
            {
                flag=1
            }
        </>
        :
        last=value
    )
    coef = 100/first*0.8;

    var minznach = 10000;
    var maxznach = 0;

    if(metrics?.targets[1]?.confusionMatrix.tn<minznach)
    {
        minznach=metrics?.targets[1]?.confusionMatrix.tn
    }
    if(metrics?.targets[1]?.confusionMatrix.tn>maxznach)
    {
        maxznach=metrics?.targets[1]?.confusionMatrix.tn
    }

    if(metrics?.targets[1]?.confusionMatrix.fn<minznach)
    {
        minznach=metrics?.targets[1]?.confusionMatrix.fn
    }
    if(metrics?.targets[1]?.confusionMatrix.fn>maxznach)
    {
        maxznach=metrics?.targets[1]?.confusionMatrix.fn
    }

    if(metrics?.targets[1]?.confusionMatrix.fp<minznach)
    {
        minznach=metrics?.targets[1]?.confusionMatrix.fp
    }
    if(metrics?.targets[1]?.confusionMatrix.fp>maxznach)
    {
        maxznach=metrics?.targets[1]?.confusionMatrix.fp
    }

    if(metrics?.targets[1]?.confusionMatrix.tp<minznach)
    {
        minznach=metrics?.targets[1]?.confusionMatrix.tp
    }
    if(metrics?.targets[1]?.confusionMatrix.tp>maxznach)
    {
        maxznach=metrics?.targets[1]?.confusionMatrix.tp
    }

    var period = (maxznach - minznach)/5;



    var minznachmulty = 10000;
    var maxznachmulty = 0;
    metrics?.targets?.map((n,i)=>
        <>
        {
            metrics?.targets[metrics?.targets.length-1]?.confusionMatrix[i]?.map((z, u)=>
                minznachmulty>z?(minznachmulty=z):<></>
            
            )
        }
        </>
    )
    metrics?.targets?.map((n,i)=>
        <>
        {
            metrics?.targets[metrics?.targets.length-1]?.confusionMatrix[i]?.map((z, u)=>
                maxznachmulty<z?(maxznachmulty=z):<></>
            )
        }
        </>
    )

    var periodmulty = (maxznachmulty - minznachmulty)/(metrics?.targets.length-1);



    var minznach3 = 10000;
    var maxznach3 = 0;
    if(metrics?.targets.length>2)
    {
        if(metrics?.targets[2].target==null)
        {}
        else
        {
            if(metrics?.targets[3].target==null)
            {
                if(metrics?.targets[3]?.confusionMatrix[0][0]||0<minznach3)
                {
                    minznach3=metrics?.targets[3]?.confusionMatrix[0][0]
                }
                if(metrics?.targets[3]?.confusionMatrix[0][0]||0>maxznach3)
                {
                    maxznach3=metrics?.targets[3]?.confusionMatrix[0][0]
                }

                if(metrics?.targets[3]?.confusionMatrix[0][1]||0<minznach3)
                {
                    minznach3=metrics?.targets[3]?.confusionMatrix[0][1]
                }
                if(metrics?.targets[3]?.confusionMatrix[0][1]||0>maxznach3)
                {
                    maxznach3=metrics?.targets[3]?.confusionMatrix[0][1]
                }

                if(metrics?.targets[3]?.confusionMatrix[0][2]||0<minznach3)
                {
                    minznach3=metrics?.targets[3]?.confusionMatrix[0][2]
                }
                if(metrics?.targets[3]?.confusionMatrix[0][2]||0>maxznach3)
                {
                    maxznach3=metrics?.targets[3]?.confusionMatrix[0][2]
                }


                if(metrics?.targets[3]?.confusionMatrix[1][0]||0<minznach3)
                {
                    minznach3=metrics?.targets[3]?.confusionMatrix[1][0]
                }
                if(metrics?.targets[3]?.confusionMatrix[1][0]||0>maxznach3)
                {
                    maxznach3=metrics?.targets[3]?.confusionMatrix[1][0]
                }


                if(metrics?.targets[3]?.confusionMatrix[1][1]||0<minznach3)
                {
                    minznach3=metrics?.targets[3]?.confusionMatrix[1][1]
                }
                if(metrics?.targets[3]?.confusionMatrix[1][1]||0>maxznach3)
                {
                    maxznach3=metrics?.targets[3]?.confusionMatrix[1][1]
                }


                if(metrics?.targets[3]?.confusionMatrix[1][2]||0<minznach3)
                {
                    minznach3=metrics?.targets[3]?.confusionMatrix[1][2]
                }
                if(metrics?.targets[3]?.confusionMatrix[1][2]||0>maxznach3)
                {
                    maxznach3=metrics?.targets[3]?.confusionMatrix[1][2]
                }


                if(metrics?.targets[3]?.confusionMatrix[2][0]||0<minznach3)
                {
                    minznach3=metrics?.targets[3]?.confusionMatrix[2][0]
                }
                if(metrics?.targets[3]?.confusionMatrix[2][0]||0>maxznach3)
                {
                    maxznach3=metrics?.targets[3]?.confusionMatrix[2][0]
                }


                if(metrics?.targets[3]?.confusionMatrix[2][1]<minznach3)
                {
                    minznach3=metrics?.targets[3]?.confusionMatrix[2][1]
                }
                if(metrics?.targets[3]?.confusionMatrix[2][1]>maxznach3)
                {
                    maxznach3=metrics?.targets[3]?.confusionMatrix[2][1]
                }


                if(metrics?.targets[3]?.confusionMatrix[2][2]<minznach3)
                {
                    minznach3=metrics?.targets[3]?.confusionMatrix[2][2]
                }
                if(metrics?.targets[3]?.confusionMatrix[2][2]>maxznach3)
                {
                    maxznach3=metrics?.targets[3]?.confusionMatrix[2][2]
                }
            }
        }
    }


    var period3 = (maxznach3 - minznach3)/5;

    var labels = [];
    var datas = [];
  
    Object.entries(topFieldsObj||[]).sort(([,a],[,b]) => a-b).reverse().slice(0, 10).map(([key, value])=>
        labels.push(key?.replaceAll("impact_", "")+" ("+(Math.round(value * 100) / 100).toFixed(2)+")")
    )
    Object.entries(topFieldsObj||[]).sort(([,a],[,b]) => a-b).reverse().slice(0, 10).map(([key, value])=>
        datas.push(Number((Math.round(value * 100) / 100)))
    )

    const dataChart = {
        labels: labels,
        datasets:[
            {
                data: datas,
                backgroundColor: 'rgba(66, 133, 244, 1)',
                color: "rgba(2, 2, 3, 1)",
                height:20
            }
        ]
    };
    const optionsChart = {
        indexAxis: 'y',
        layout:{
            padding: 20
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false
            }
        },
        scales:{
            x:{
                grid:{
                    drawOnChartArea: false
                }
            },
            y:{
                grid:{
                    drawOnChartArea: false
                },
                ticks:{
                    color:"black"
                }
            }
        },
        tooltips: {
            callbacks: {
               label: function(tooltipItem) {
                      return tooltipItem.yLabel;
               }
            }
        }
    };

    console.log(GlobalState.activemodel);
   
    return (
        < >
            {
                metrics?.targets.length>2?
                    metrics?.targets[2].target==null?
                    <div className='contop_block'>
                        <div className='contop_block_left '>
                            <div className='contop_block_title'>
                            {langv?.module_models?.contop?.text1}
                            </div>
                            <div className='contop_block_left_body'>
                                <div className='contop_block_left_body_1'>
                                    <span>{langv?.module_models?.contop?.text2}</span>
                                </div>
                                <div className='contop_block_left_body_2'>
                                    <div className='contop_block_left_body_2_line'>
                                    {langv?.module_models?.contop?.text3}
                                    </div>
                                    <div className='contop_block_left_body_2_line_bl'>
                                        <div className='contop_block_left_body_2_line_1'>
                                            <div className='contop_block_left_col_1'>

                                            </div>
                                            <div className='contop_block_left_col_2 '>
                                                
                                                {
                                                    metrics?.targets[0]?.target.length>9?
                                                    <></>
                                                    :
                                                    metrics?.targets[0]?.target
                                                }
                                                {   
                                                    metrics?.targets[0]?.target.length>9?
                                                    <>
                                                    {metrics?.targets[0]?.target.substr(0, 8)}
                                                    <span className='open_tooltipa_head_prew'> ...
                                                        <div className='tooltipa_head_prew'>{metrics?.targets[0]?.target}</div>
                                                    </span>
                                                    
                                                    </>
                                                    :
                                                    <></>
                                                }
                                            </div>
                                            <div className='contop_block_left_col_3'>
                                               
                                                {
                                                    metrics?.targets[1]?.target.length>9?
                                                    <></>
                                                    :
                                                    metrics?.targets[1]?.target
                                                }
                                                {   
                                                    metrics?.targets[1]?.target.length>9?
                                                    <>
                                                    {metrics?.targets[1]?.target.substr(0, 8)}
                                                    <span className='open_tooltipa_head_prew'> ...
                                                        <div className='tooltipa_head_prew'>{metrics?.targets[1]?.target}</div>
                                                    </span>
                                                    
                                                    </>
                                                    :
                                                    <></>
                                                }
                                            </div> 
                                            
                                        </div>
                                        <div className='contop_block_left_body_2_line_2'>
                                            <div className='contop_block_left_col_1'>
                                               
                                                {
                                                    metrics?.targets[0]?.target.length>9?
                                                    <></>
                                                    :
                                                    metrics?.targets[0]?.target
                                                }
                                                {   
                                                    metrics?.targets[0]?.target.length>9?
                                                    <>
                                                    {metrics?.targets[0]?.target.substr(0, 8)}
                                                    <span className='open_tooltipa_head_prew'> ...
                                                        <div className='tooltipa_head_prew'>{metrics?.targets[0]?.target}</div>
                                                    </span>
                                                    
                                                    </>
                                                    :
                                                    <></>
                                                }
                                            </div>
                                            <div className='contop_block_left_col_2 vb1'>
                                                {metrics?.targets[2]?.confusionMatrix[0][0]}
                                            </div>
                                            <div className='contop_block_left_col_3 vb2'>
                                                {metrics?.targets[2]?.confusionMatrix[0][1]}
                                            </div>
                                            
                                        </div>
                                        <div className='contop_block_left_body_2_line_2'>
                                            <div className='contop_block_left_col_1'>
                                                
                                                {
                                                    metrics?.targets[1]?.target.length>9?
                                                    <></>
                                                    :
                                                    metrics?.targets[1]?.target
                                                }
                                                {   
                                                    metrics?.targets[1]?.target.length>9?
                                                    <>
                                                    {metrics?.targets[1]?.target.substr(0, 8)}
                                                    <span className='open_tooltipa_head_prew'> ...
                                                        <div className='tooltipa_head_prew'>{metrics?.targets[1]?.target}</div>
                                                    </span>
                                                    
                                                    </>
                                                    :
                                                    <></>
                                                }
                                            </div>
                                            <div className='contop_block_left_col_2 vb3'>
                                                {metrics?.targets[2]?.confusionMatrix[1][0]}
                                            </div>
                                            <div className='contop_block_left_col_3 vb4'>
                                                {metrics?.targets[2]?.confusionMatrix[1][1]}
                                            </div>
                                            
                                        </div>
                                        
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <div className='contop_block_right'>
                            <div className='contop_block_title'>
                            {langv?.module_models?.contop?.text4}
                            </div>
                            <div className='contop_block_right_body'>
                                {/* <div className='contop_block_right_body_line_1'>
                                    {
                                        Object.entries(topFieldsObj).sort(([,a],[,b]) => a-b).reverse().slice(0,10).map(([key, value])=>
                                            <div className='contop_block_right_body_line'>
                                                {key}
                                            </div>
                                        )
                                    }
                                </div>
                                <div className='contop_block_right_body_line_2 lintop_bl'>
                                    {
                                        
                                        Object.entries(topFieldsObj).sort(([,a],[,b]) => a-b).reverse().slice(0,10).map(([key, value])=>
                                            <div className='contop_block_right_body_line'>
                                                <div style={{width: value*coef+"%"}}></div>
                                                <span>{value.toFixed(2)}</span>
                                            </div>
                                        )
                                    }
                                </div> */}
                                <Bar data={dataChart} options={optionsChart}/>
                            </div>
                        </div>
                    </div>
          
                    :
                        metrics?.targets[3].target==null?
                        <div className='contop_block'>
                            <div className='contop_block_left zeretmortis'>
                                <div className='contop_block_title' style={{paddingBottom:"0px"}}>
                                {langv?.module_models?.contop?.text1}
                                </div>
                                <div className='contop_block_left_body'>
                                    <div className='contop_block_left_body_1'>
                                        <span>{langv?.module_models?.contop?.text3}</span>
                                    </div>
                                    <div className='contop_block_left_body_2'>
                                        <div className='contop_block_left_body_2_line'>
                                        {langv?.module_models?.contop?.text2}
                                        </div>
                                        <div className='contop_block_left_body_2_line_bl'>
                                            <div className='contop_block_left_body_2_line_1'>
                                                <div className='contop_block_left_col_1'>

                                                </div>
                                                <div className='contop_block_left_col_2 ' style={{minWidth: "calc( ( 100% - 80px ) / 3 )"}}>
                                                  
                                                    {
                                                        metrics?.targets[0]?.target.length>9?
                                                        <></>
                                                        :
                                                        metrics?.targets[0]?.target
                                                    }
                                                    {   
                                                        metrics?.targets[0]?.target.length>9?
                                                        <>
                                                        {metrics?.targets[0]?.target.substr(0, 8)}
                                                        <span className='open_tooltipa_head_prew'> ...
                                                            <div className='tooltipa_head_prew'>{metrics?.targets[0]?.target}</div>
                                                        </span>
                                                        
                                                        </>
                                                        :
                                                        <></>
                                                    }
                                                </div>
                                                <div className='contop_block_left_col_3' style={{minWidth: "calc( ( 100% - 80px ) / 3 )"}}>
                                                   
                                                    {
                                                        metrics?.targets[1]?.target.length>9?
                                                        <></>
                                                        :
                                                        metrics?.targets[1]?.target
                                                    }
                                                    {   
                                                        metrics?.targets[1]?.target.length>9?
                                                        <>
                                                        {metrics?.targets[1]?.target.substr(0, 8)}
                                                        <span className='open_tooltipa_head_prew'> ...
                                                            <div className='tooltipa_head_prew'>{metrics?.targets[1]?.target}</div>
                                                        </span>
                                                        
                                                        </>
                                                        :
                                                        <></>
                                                    }
                                                </div> 
                                                <div className='contop_block_left_col_3' style={{minWidth: "calc( ( 100% - 80px ) / 3 )"}}>
                                              
                                                    {
                                                        metrics?.targets[2]?.target.length>9?
                                                        <></>
                                                        :
                                                        metrics?.targets[2]?.target
                                                    }
                                                    {   
                                                        metrics?.targets[2]?.target.length>9?
                                                        <>
                                                        {metrics?.targets[2]?.target.substr(0, 8)}
                                                        <span className='open_tooltipa_head_prew'> ...
                                                            <div className='tooltipa_head_prew'>{metrics?.targets[2]?.target}</div>
                                                        </span>
                                                        
                                                        </>
                                                        :
                                                        <></>
                                                    }
                                                </div>  
                                            </div>
                                            <div className='contop_block_left_body_2_line_2'>
                                                <div className='contop_block_left_col_1' >
                                                   
                                                    {
                                                        metrics?.targets[0]?.target.length>9?
                                                        <></>
                                                        :
                                                        metrics?.targets[0]?.target
                                                    }
                                                    {   
                                                        metrics?.targets[0]?.target.length>9?
                                                        <>
                                                        {metrics?.targets[0]?.target.substr(0, 8)}
                                                        <span className='open_tooltipa_head_prew'> ...
                                                            <div className='tooltipa_head_prew'>{metrics?.targets[0]?.target}</div>
                                                        </span>
                                                        
                                                        </>
                                                        :
                                                        <></>
                                                    }
                                                </div>
                                                <div className='contop_block_left_col_2 vb1' style={
                                                    metrics?.targets[3]?.confusionMatrix[0][0]>=0&&metrics?.targets[3]?.confusionMatrix[0][0]<(period3)?
                                                    {background:"rgba(218, 232, 253, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )", borderTopLeftRadius:"8px"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[0][0]>=(period3)&&metrics?.targets[3]?.confusionMatrix[0][0]<(period3*2)?
                                                    {background:"rgba(193, 216, 252, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )", borderTopLeftRadius:"8px"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[0][0]>=(period3*2)&&metrics?.targets[3]?.confusionMatrix[0][0]<(period3*3)?
                                                    {background:"rgba(169, 199, 251, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )", borderTopLeftRadius:"8px"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[0][0]>=(period3*3)&&metrics?.targets[3]?.confusionMatrix[0][0]<(period3*4)?
                                                    {background:"rgba(149, 187, 249, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )", borderTopLeftRadius:"8px"}
                                                    :
                                                    {background:"rgba(121, 169, 248, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )", borderTopLeftRadius:"8px"}
                                                }>
                                                    {metrics?.targets[3]?.confusionMatrix[0][0]}
                                                </div>
                                                <div className='contop_block_left_col_3 vb2' style={
                                                    metrics?.targets[3]?.confusionMatrix[0][1]>=0&&metrics?.targets[3]?.confusionMatrix[0][1]<(period3)?
                                                    {background:"rgba(218, 232, 253, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )", borderRadius:"0px"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[0][1]>=(period3)&&metrics?.targets[3]?.confusionMatrix[0][1]<(period3*2)?
                                                    {background:"rgba(193, 216, 252, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )", borderRadius:"0px"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[0][1]>=(period3*2)&&metrics?.targets[3]?.confusionMatrix[0][1]<(period3*3)?
                                                    {background:"rgba(169, 199, 251, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )", borderRadius:"0px"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[0][1]>=(period3*3)&&metrics?.targets[3]?.confusionMatrix[0][1]<(period3*4)?
                                                    {background:"rgba(149, 187, 249, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )", borderRadius:"0px"}
                                                    :
                                                    {background:"rgba(121, 169, 248, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )", borderRadius:"0px"}
                                                }>
                                                    {metrics?.targets[3]?.confusionMatrix[0][1]}
                                                </div>
                                                <div className='contop_block_left_col_3 vbmurly3' style={
                                                    metrics?.targets[3]?.confusionMatrix[0][2]>=0&&metrics?.targets[3]?.confusionMatrix[0][2]<(period3)?
                                                    {background:"rgba(218, 232, 253, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )", borderLeft:"0px",  borderTopRightRadius:"8px"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[0][2]>=(period3)&&metrics?.targets[3]?.confusionMatrix[0][2]<(period3*2)?
                                                    {background:"rgba(193, 216, 252, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )", borderLeft:"0px",  borderTopRightRadius:"8px"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[0][2]>=(period3*2)&&metrics?.targets[3]?.confusionMatrix[0][2]<(period3*3)?
                                                    {background:"rgba(169, 199, 251, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )", borderLeft:"0px",  borderTopRightRadius:"8px"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[0][2]>=(period3*3)&&metrics?.targets[3]?.confusionMatrix[0][2]<(period3*4)?
                                                    {background:"rgba(149, 187, 249, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )", borderLeft:"0px",  borderTopRightRadius:"8px"}
                                                    :
                                                    {background:"rgba(121, 169, 248, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )", borderLeft:"0px",  borderTopRightRadius:"8px"}
                                                }>
                                                    {metrics?.targets[3]?.confusionMatrix[0][2]}
                                                </div>
                                            </div>
                                            <div className='contop_block_left_body_2_line_2'>
                                                <div className='contop_block_left_col_1'>
                                                  
                                                    {
                                                        metrics?.targets[1]?.target.length>9?
                                                        <></>
                                                        :
                                                        metrics?.targets[1]?.target
                                                    }
                                                    {   
                                                        metrics?.targets[1]?.target.length>9?
                                                        <>
                                                        {metrics?.targets[1]?.target.substr(0, 8)}
                                                        <span className='open_tooltipa_head_prew'> ...
                                                            <div className='tooltipa_head_prew'>{metrics?.targets[1]?.target}</div>
                                                        </span>
                                                        
                                                        </>
                                                        :
                                                        <></>
                                                    }
                                                </div>
                                                <div className='contop_block_left_col_2 vbmulty02' style={
                                                    metrics?.targets[3]?.confusionMatrix[1][0]>=0&&metrics?.targets[3]?.confusionMatrix[1][0]<(period3)?
                                                    {background:"rgba(218, 232, 253, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[1][0]>=(period3)&&metrics?.targets[3]?.confusionMatrix[1][0]<(period3*2)?
                                                    {background:"rgba(193, 216, 252, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[1][0]>=(period3*2)&&metrics?.targets[3]?.confusionMatrix[1][0]<(period3*3)?
                                                    {background:"rgba(169, 199, 251, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[1][0]>=(period3*3)&&metrics?.targets[3]?.confusionMatrix[1][0]<(period3*4)?
                                                    {background:"rgba(149, 187, 249, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                    :
                                                    {background:"rgba(121, 169, 248, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                }>
                                                    {metrics?.targets[3]?.confusionMatrix[1][0]}
                                                </div>
                                                <div className='contop_block_left_col_3 vbmulty2'  style={
                                                    metrics?.targets[3]?.confusionMatrix[1][1]>=0&&metrics?.targets[3]?.confusionMatrix[1][1]<(period3)?
                                                    {background:"rgba(218, 232, 253, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[1][1]>=(period3)&&metrics?.targets[3]?.confusionMatrix[1][1]<(period3*2)?
                                                    {background:"rgba(193, 216, 252, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[1][1]>=(period3*2)&&metrics?.targets[3]?.confusionMatrix[1][1]<(period3*3)?
                                                    {background:"rgba(169, 199, 251, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[1][1]>=(period3*3)&&metrics?.targets[3]?.confusionMatrix[1][1]<(period3*4)?
                                                    {background:"rgba(149, 187, 249, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                    :
                                                    {background:"rgba(121, 169, 248, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                }>
                                                    {metrics?.targets[3]?.confusionMatrix[1][1]}
                                                </div>
                                                <div className='contop_block_left_col_3 vbmulty2'  style={
                                                    metrics?.targets[3]?.confusionMatrix[1][2]>=0&&metrics?.targets[3]?.confusionMatrix[1][2]<(period3)?
                                                    {background:"rgba(218, 232, 253, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[1][2]>=(period3)&&metrics?.targets[3]?.confusionMatrix[1][2]<(period3*2)?
                                                    {background:"rgba(193, 216, 252, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[1][2]>=(period3*2)&&metrics?.targets[3]?.confusionMatrix[1][2]<(period3*3)?
                                                    {background:"rgba(169, 199, 251, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[1][2]>=(period3*3)&&metrics?.targets[3]?.confusionMatrix[1][2]<(period3*4)?
                                                    {background:"rgba(149, 187, 249, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                    :
                                                    {background:"rgba(121, 169, 248, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                }>
                                                    {metrics?.targets[3]?.confusionMatrix[1][2]}
                                                </div>
                                            </div>
                                            <div className='contop_block_left_body_2_line_2'>
                                                <div className='contop_block_left_col_1' >

                                                    {
                                                        metrics?.targets[2]?.target.length>9?
                                                        <></>
                                                        :
                                                        metrics?.targets[2]?.target
                                                    }
                                                    {   
                                                        metrics?.targets[2]?.target.length>9?
                                                        <>
                                                        {metrics?.targets[2]?.target.substr(0, 8)}
                                                        <span className='open_tooltipa_head_prew'> ...
                                                            <div className='tooltipa_head_prew'>{metrics?.targets[2]?.target}</div>
                                                        </span>
                                                        
                                                        </>
                                                        :
                                                        <></>
                                                    }
                                                    
                                                </div>
                                                <div className='contop_block_left_col_2 vbmulty13'  style={
                                                    metrics?.targets[3]?.confusionMatrix[2][0]>=0&&metrics?.targets[3]?.confusionMatrix[2][0]<(period3)?
                                                    {background:"rgba(218, 232, 253, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[2][0]>=(period3)&&metrics?.targets[3]?.confusionMatrix[2][0]<(period3*2)?
                                                    {background:"rgba(193, 216, 252, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[2][0]>=(period3*2)&&metrics?.targets[3]?.confusionMatrix[2][0]<(period3*3)?
                                                    {background:"rgba(169, 199, 251, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[2][0]>=(period3*3)&&metrics?.targets[3]?.confusionMatrix[2][0]<(period3*4)?
                                                    {background:"rgba(149, 187, 249, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                    :
                                                    {background:"rgba(121, 169, 248, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                }>
                                                    {metrics?.targets[3]?.confusionMatrix[2][0]}
                                                </div>
                                                <div className='contop_block_left_col_3 vbmulty23' style={
                                                    metrics?.targets[3]?.confusionMatrix[2][1]>=0&&metrics?.targets[3]?.confusionMatrix[2][1]<(period3)?
                                                    {background:"rgba(218, 232, 253, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[2][1]>=(period3)&&metrics?.targets[3]?.confusionMatrix[2][1]<(period3*2)?
                                                    {background:"rgba(193, 216, 252, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[2][1]>=(period3*2)&&metrics?.targets[3]?.confusionMatrix[2][1]<(period3*3)?
                                                    {background:"rgba(169, 199, 251, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[2][1]>=(period3*3)&&metrics?.targets[3]?.confusionMatrix[2][1]<(period3*4)?
                                                    {background:"rgba(149, 187, 249, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                    :
                                                    {background:"rgba(121, 169, 248, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                }>
                                                    {metrics?.targets[3]?.confusionMatrix[2][1]}
                                                </div>
                                                <div className='contop_block_left_col_3 vbmulty33' style={
                                                    metrics?.targets[3]?.confusionMatrix[2][2]>=0&&metrics?.targets[3]?.confusionMatrix[2][2]<(period3)?
                                                    {background:"rgba(218, 232, 253, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[2][2]>=(period3)&&metrics?.targets[3]?.confusionMatrix[2][2]<(period3*2)?
                                                    {background:"rgba(193, 216, 252, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[2][2]>=(period3*2)&&metrics?.targets[3]?.confusionMatrix[2][2]<(period3*3)?
                                                    {background:"rgba(169, 199, 251, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                    :
                                                    metrics?.targets[3]?.confusionMatrix[2][2]>=(period3*3)&&metrics?.targets[3]?.confusionMatrix[2][2]<(period3*4)?
                                                    {background:"rgba(149, 187, 249, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                    :
                                                    {background:"rgba(121, 169, 248, 1)", minWidth: "calc( ( 100% - 80px ) / 3 )"}
                                                }> 
                                                    {metrics?.targets[3]?.confusionMatrix[2][2]}
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                            <div className='contop_block_right'>
                                <div className='contop_block_title'>
                                {langv?.module_models?.contop?.text4}
                                </div>
                                <div className='contop_block_right_body'>
                                    {/* <div className='contop_block_right_body_line_1'>
                                        {
                                            Object.entries(topFieldsObj).sort(([,a],[,b]) => a-b).reverse().slice(0,10).map(([key, value])=>
                                                <div className='contop_block_right_body_line'>
                                                    {key}
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div className='contop_block_right_body_line_2 lintop_bl'>
                                        {
                                            
                                            Object.entries(topFieldsObj).sort(([,a],[,b]) => a-b).reverse().slice(0,10).map(([key, value])=>
                                                <div className='contop_block_right_body_line'>
                                                    <div style={{width: value*coef+"%"}}></div>
                                                    <span>{value.toFixed(2)}</span>
                                                </div>
                                            )
                                        }
                                    </div> */}
                                    <Bar data={dataChart} options={optionsChart}/>
                                </div>
                            </div>
                        </div>
                        :
                        <div className='contop_block zeretabmortis_line'>
                            <div className='contop_block_left zeretabmortis'>
                                <div className='contop_block_title'>
                                {langv?.module_models?.contop?.text1}
                                </div>
                                <div className='contop_block_left_body'>
                                    <div className='contop_block_left_body_1'>
                                        <span>{langv?.module_models?.contop?.text2}</span>
                                    </div>
                                    <div className='contop_block_left_body_2'>
                                        <div className='contop_block_left_body_2_line'>
                                        {langv?.module_models?.contop?.text3}
                                        </div>
                                        <div className='contop_block_left_body_2_line_bl alik'>
                                            <div className='contop_block_left_body_2_line_1'>
                                                <div className='contop_block_left_col_1'>

                                                </div>
                                                {
                                                    metrics?.targets?.map((n,i)=>
                                                        n.target!=null?
                                                        <div className='contop_block_left_col_2' style={{minWidth: "calc( ( 100% "+otstup2+") / "+(metrics?.targets.length-1) +" )"}}>
                                                           
                                                            {
                                                                n.target.length>9?
                                                                <></>
                                                                :
                                                                n.target
                                                            }
                                                            {   
                                                               n.target.length>9?
                                                                <>
                                                                {n.target.substr(0, 8)}
                                                                <span className='open_tooltipa_head_prew'> ...
                                                                    <div className='tooltipa_head_prew'>{n.target}</div>
                                                                </span>
                                                                
                                                                </>
                                                                :
                                                                <></>
                                                            }
                                                        </div>
                                                        :
                                                        <></>
                                                    )
                                                }
                                            </div>
                                            {
                                                metrics?.targets?.map((n,i)=>
                                                    n.target!=null?
                                                    <div className='contop_block_left_body_2_line_2'>
                                                        <div className='contop_block_left_col_1'>
                                                            
                                                            {
                                                                n.target.length>9?
                                                                <></>
                                                                :
                                                                n.target
                                                            }
                                                            {   
                                                               n.target.length>9?
                                                                <>
                                                                {n.target.substr(0, 8)}
                                                                <span className='open_tooltipa_head_prew'> ...
                                                                    <div className='tooltipa_head_prew'>{n.target}</div>
                                                                </span>
                                                                
                                                                </>
                                                                :
                                                                <></>
                                                            }
                                                           
                                                        </div>
                                                        {
                                                            metrics?.targets[metrics?.targets.length-1].confusionMatrix[i].map((z, u)=>
                                                                
                                                                i==u?
                                                                i==0&&u==0?
                                                                <div className={'contop_block_left_col_2 vbmulty1'} style={ 
                                                                    z>=0&&z<(periodmulty)?
                                                                    {background:"rgba(218, 232, 253, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderTopLeftRadius:"8px", border:"4px solid rgba(19, 103, 241, 1)", padding: "0px"}
                                                                    :
                                                                    z>=(periodmulty)&&z<(periodmulty*2)?
                                                                    {background:"rgba(193, 216, 252, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderTopLeftRadius:"8px", border:"4px solid rgba(19, 103, 241, 1)", padding: "0px"}
                                                                    :
                                                                    z>=(periodmulty*2)&&z<(periodmulty*3)?
                                                                    {background:"rgba(169, 199, 251, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderTopLeftRadius:"8px", border:"4px solid rgba(19, 103, 241, 1)", padding: "0px"}
                                                                    :
                                                                    z>=(periodmulty*3)&&z<(periodmulty*4)?
                                                                    {background:"rgba(149, 187, 249, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderTopLeftRadius:"8px", border:"4px solid rgba(19, 103, 241, 1)", padding: "0px"}
                                                                    :
                                                                    {background:"rgba(121, 169, 248, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderTopLeftRadius:"8px", border:"4px solid rgba(19, 103, 241, 1)", padding: "0px"}
                                                                    }>
                                                                    {z}
                                                                </div>
                                                                :
                                                                i==0&&u==(metrics?.targets[metrics?.targets.length-1].confusionMatrix[i].length-1)?
                                                                <div className={'contop_block_left_col_2 vbmulty1'} style={ 
                                                                    z>=0&&z<(periodmulty)?
                                                                    {background:"rgba(218, 232, 253, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderTopRightRadius:"8px", border:"4px solid rgba(19, 103, 241, 1)", padding: "0px"}
                                                                    :
                                                                    z>=(periodmulty)&&z<(periodmulty*2)?
                                                                    {background:"rgba(193, 216, 252, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderTopRightRadius:"8px", border:"4px solid rgba(19, 103, 241, 1)", padding: "0px"}
                                                                    :
                                                                    z>=(periodmulty*2)&&z<(periodmulty*3)?
                                                                    {background:"rgba(169, 199, 251, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderTopRightRadius:"8px", border:"4px solid rgba(19, 103, 241, 1)", padding: "0px"}
                                                                    :
                                                                    z>=(periodmulty*3)&&z<(periodmulty*4)?
                                                                    {background:"rgba(149, 187, 249, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderTopRightRadius:"8px", border:"4px solid rgba(19, 103, 241, 1)", padding: "0px"}
                                                                    :
                                                                    {background:"rgba(121, 169, 248, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderTopRightRadius:"8px", border:"4px solid rgba(19, 103, 241, 1)", padding: "0px"}
                                                                    }>
                                                                    {z}
                                                                    
                                                                </div>
                                                                :
                                                                i==(metrics?.targets.length-2)&&u==(metrics?.targets[metrics?.targets.length-1].confusionMatrix[i].length-1)?
                                                                <div className={'contop_block_left_col_2 vbmulty1'} style={ 
                                                                    z>=0&&z<(periodmulty)?
                                                                    {background:"rgba(218, 232, 253, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderBottomRightRadius:"8px", border:"4px solid rgba(19, 103, 241, 1)", padding: "0px"}
                                                                    :
                                                                    z>=(periodmulty)&&z<(periodmulty*2)?
                                                                    {background:"rgba(193, 216, 252, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderBottomRightRadius:"8px", border:"4px solid rgba(19, 103, 241, 1)", padding: "0px"}
                                                                    :
                                                                    z>=(periodmulty*2)&&z<(periodmulty*3)?
                                                                    {background:"rgba(169, 199, 251, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderBottomRightRadis:"8px", border:"4px solid rgba(19, 103, 241, 1)", padding: "0px"}
                                                                    :
                                                                    z>=(periodmulty*3)&&z<(periodmulty*4)?
                                                                    {background:"rgba(149, 187, 249, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderBottomRightRadius:"8px", border:"4px solid rgba(19, 103, 241, 1)", padding: "0px"}
                                                                    :
                                                                    {background:"rgba(121, 169, 248, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderBottomRightRadius:"8px", border:"4px solid rgba(19, 103, 241, 1)", padding: "0px"}
                                                                    }>
                                                                    {z}
                                                                    
                                                                </div>
                                                                :
                                                                i==(metrics?.targets.length-2)&&u==0?
                                                                <div className={'contop_block_left_col_2 vbmulty1'} style={ 
                                                                    z>=0&&z<(periodmulty)?
                                                                    {background:"rgba(218, 232, 253, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderBottomLeftRadius:"8px", border:"4px solid rgba(19, 103, 241, 1)", padding: "0px"}
                                                                    :
                                                                    z>=(periodmulty)&&z<(periodmulty*2)?
                                                                    {background:"rgba(193, 216, 252, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderBottomLeftRadius:"8px", border:"4px solid rgba(19, 103, 241, 1)", padding: "0px"}
                                                                    :
                                                                    z>=(periodmulty*2)&&z<(periodmulty*3)?
                                                                    {background:"rgba(169, 199, 251, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderBottomLeftRadiu:"8px", border:"4px solid rgba(19, 103, 241, 1)", padding: "0px"}
                                                                    :
                                                                    z>=(periodmulty*3)&&z<(periodmulty*4)?
                                                                    {background:"rgba(149, 187, 249, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderBottomLeftRadiu:"8px", border:"4px solid rgba(19, 103, 241, 1)", padding: "0px"}
                                                                    :
                                                                    {background:"rgba(121, 169, 248, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderBottomLeftRadiu:"8px", border:"4px solid rgba(19, 103, 241, 1)", padding: "0px"}
                                                                    }>
                                                                    {z}
                                                                    
                                                                </div>
                                                                :
                                                                <div className={'contop_block_left_col_2 vbmulty1'} style={ 
                                                                    z>=0&&z<(periodmulty)?
                                                                    {background:"rgba(218, 232, 253, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", border:"4px solid rgba(19, 103, 241, 1)", padding: "0px"}
                                                                    :
                                                                    z>=(periodmulty)&&z<(periodmulty*2)?
                                                                    {background:"rgba(193, 216, 252, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", border:"4px solid rgba(19, 103, 241, 1)", padding: "0px"}
                                                                    :
                                                                    z>=(periodmulty*2)&&z<(periodmulty*3)?
                                                                    {background:"rgba(169, 199, 251, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", border:"4px solid rgba(19, 103, 241, 1)", padding: "0px"}
                                                                    :
                                                                    z>=(periodmulty*3)&&z<(periodmulty*4)?
                                                                    {background:"rgba(149, 187, 249, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", border:"4px solid rgba(19, 103, 241, 1)", padding: "0px"}
                                                                    :
                                                                    {background:"rgba(121, 169, 248, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", border:"4px solid rgba(19, 103, 241, 1)", padding: "0px"}
                                                                    }>
                                                                    {z}
                                                                </div>
                                                                :
                                                                i==0&&u==0?
                                                                <div className={'contop_block_left_col_2 vbmulty1'} style={ 
                                                                    z>=0&&z<(periodmulty)?
                                                                    {background:"rgba(218, 232, 253, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderTopLeftRadius:"8px", padding: "3px"}
                                                                    :
                                                                    z>=(periodmulty)&&z<(periodmulty*2)?
                                                                    {background:"rgba(193, 216, 252, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderTopLeftRadius:"8px", padding: "3px"}
                                                                    :
                                                                    z>=(periodmulty*2)&&z<(periodmulty*3)?
                                                                    {background:"rgba(169, 199, 251, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderTopLeftRadius:"8px", padding: "3px"}
                                                                    :
                                                                    z>=(periodmulty*3)&&z<(periodmulty*4)?
                                                                    {background:"rgba(149, 187, 249, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderTopLeftRadius:"8px", padding: "3px"}
                                                                    :
                                                                    {background:"rgba(121, 169, 248, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderTopLeftRadius:"8px", padding: "3px"}
                                                                    }>
                                                                    {z}
                                                                </div>
                                                                :
                                                                i==0&&u==(metrics?.targets[metrics?.targets.length-1].confusionMatrix[i].length-1)?
                                                                <div className={'contop_block_left_col_2 vbmulty1'} style={ 
                                                                    z>=0&&z<(periodmulty)?
                                                                    {background:"rgba(218, 232, 253, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderTopRightRadius:"8px", padding: "3px"}
                                                                    :
                                                                    z>=(periodmulty)&&z<(periodmulty*2)?
                                                                    {background:"rgba(193, 216, 252, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderTopRightRadius:"8px", padding: "3px"}
                                                                    :
                                                                    z>=(periodmulty*2)&&z<(periodmulty*3)?
                                                                    {background:"rgba(169, 199, 251, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderTopRightRadius:"8px", padding: "3px"}
                                                                    :
                                                                    z>=(periodmulty*3)&&z<(periodmulty*4)?
                                                                    {background:"rgba(149, 187, 249, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderTopRightRadius:"8px", padding: "3px"}
                                                                    :
                                                                    {background:"rgba(121, 169, 248, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderTopRightRadius:"8px", padding: "3px"}
                                                                    }>
                                                                    {z}
                                                                    
                                                                </div>
                                                                :
                                                                i==(metrics?.targets.length-2)&&u==(metrics?.targets[metrics?.targets.length-1].confusionMatrix[i].length-1)?
                                                                <div className={'contop_block_left_col_2 vbmulty1'} style={ 
                                                                    z>=0&&z<(periodmulty)?
                                                                    {background:"rgba(218, 232, 253, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderBottomRightRadius:"8px", padding: "3px"}
                                                                    :
                                                                    z>=(periodmulty)&&z<(periodmulty*2)?
                                                                    {background:"rgba(193, 216, 252, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderBottomRightRadius:"8px", padding: "3px"}
                                                                    :
                                                                    z>=(periodmulty*2)&&z<(periodmulty*3)?
                                                                    {background:"rgba(169, 199, 251, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderBottomRightRadis:"8px", padding: "3px"}
                                                                    :
                                                                    z>=(periodmulty*3)&&z<(periodmulty*4)?
                                                                    {background:"rgba(149, 187, 249, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderBottomRightRadius:"8px", padding: "3px"}
                                                                    :
                                                                    {background:"rgba(121, 169, 248, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderBottomRightRadius:"8px", padding: "3px"}
                                                                    }>
                                                                    {z}
                                                                    
                                                                </div>
                                                                :
                                                                i==(metrics?.targets.length-2)&&u==0?
                                                                <div className={'contop_block_left_col_2 vbmulty1'} style={ 
                                                                    z>=0&&z<(periodmulty)?
                                                                    {background:"rgba(218, 232, 253, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderBottomLeftRadius:"8px", padding: "3px"}
                                                                    :
                                                                    z>=(periodmulty)&&z<(periodmulty*2)?
                                                                    {background:"rgba(193, 216, 252, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderBottomLeftRadius:"8px", padding: "3px"}
                                                                    :
                                                                    z>=(periodmulty*2)&&z<(periodmulty*3)?
                                                                    {background:"rgba(169, 199, 251, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderBottomLeftRadiu:"8px", padding: "3px"}
                                                                    :
                                                                    z>=(periodmulty*3)&&z<(periodmulty*4)?
                                                                    {background:"rgba(149, 187, 249, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderBottomLeftRadiu:"8px", padding: "3px"}
                                                                    :
                                                                    {background:"rgba(121, 169, 248, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", borderBottomLeftRadiu:"8px", padding: "3px"}
                                                                    }>
                                                                    {z}
                                                                    
                                                                </div>
                                                                :
                                                                <div className={'contop_block_left_col_2 vbmulty1'} style={ 
                                                                    z>=0&&z<(periodmulty)?
                                                                    {background:"rgba(218, 232, 253, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", padding: "3px"}
                                                                    :
                                                                    z>=(periodmulty)&&z<(periodmulty*2)?
                                                                    {background:"rgba(193, 216, 252, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", padding: "3px"}
                                                                    :
                                                                    z>=(periodmulty*2)&&z<(periodmulty*3)?
                                                                    {background:"rgba(169, 199, 251, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", padding: "3px"}
                                                                    :
                                                                    z>=(periodmulty*3)&&z<(periodmulty*4)?
                                                                    {background:"rgba(149, 187, 249, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", padding: "3px"}
                                                                    :
                                                                    {background:"rgba(121, 169, 248, 1)", minWidth: "calc( ( 100% "+otstup+" ) / "+(metrics?.targets.length-1) +" )", padding: "3px"}
                                                                    }>
                                                                    {z}
                                                                </div>
                                                               
                                                            )
                                                        }
                                                    
                                                    </div>
                                                    :
                                                    <></>
                                                )
                                            }
                                            
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                            <div className='contop_block_right zeretabmortis'  style={{marginTop: "30px"}}>
                                <div className='contop_block_title'>
                                {langv?.module_models?.contop?.text4}
                                </div>
                                <div className='contop_block_right_body' style={{justifyContent: "center"}}>
                                    {/* <div className='contop_block_right_body_line_1'>
                                        {
                                            Object.entries(topFieldsObj).sort(([,a],[,b]) => a-b).reverse().slice(0,10).map(([key, value])=>
                                                <div className='contop_block_right_body_line'>
                                                    {key}
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div className='contop_block_right_body_line_2 lintop_bl'>
                                        {
                                            
                                            Object.entries(topFieldsObj).sort(([,a],[,b]) => a-b).reverse().slice(0,10).map(([key, value])=>
                                                <div className='contop_block_right_body_line'>
                                                    <div style={{width: value*coef+"%"}}></div>
                                                    <span>{value.toFixed(2)}</span>
                                                </div>
                                            )
                                        }
                                    </div> */}
                                    <Bar data={dataChart} options={optionsChart}/>
                                </div>
                            </div>
                        </div>
                    
                :
                <div className='contop_block'>
                    <div className='contop_block_left'>
                        <div className='contop_block_title'>
                        {langv?.module_models?.contop?.text1}
                        </div>
                        <div className='contop_block_left_body'>
                            <div className='contop_block_left_body_1'>
                                <span>{langv?.module_models?.contop?.text3}</span>
                            </div>
                            <div className='contop_block_left_body_2'>
                                <div className='contop_block_left_body_2_line'>
                                {langv?.module_models?.contop?.text2}
                                </div>
                                <div className='contop_block_left_body_2_line_bl'>
                                    <div className='contop_block_left_body_2_line_1'>
                                        <div className='contop_block_left_col_1'>

                                        </div>
                                        <div className='contop_block_left_col_2'>
                                          
                                            {
                                                metrics?.targets[0]?.target.length>9?
                                                <></>
                                                :
                                                metrics?.targets[0]?.target
                                            }
                                            {   
                                                metrics?.targets[0]?.target.length>9?
                                                <>
                                                {metrics?.targets[0]?.target.substr(0, 8)}
                                                <span className='open_tooltipa_head_prew'> ...
                                                    <div className='tooltipa_head_prew'>{metrics?.targets[0]?.target}</div>
                                                </span>
                                                
                                                </>
                                                :
                                                <></>
                                            }
                                        </div>
                                        <div className='contop_block_left_col_3'>
                                           
                                            {
                                                metrics?.targets[1]?.target.length>9?
                                                <></>
                                                :
                                                metrics?.targets[1]?.target
                                            }
                                            {   
                                                metrics?.targets[1]?.target.length>9?
                                                <>
                                                {metrics?.targets[1]?.target.substr(0, 8)}
                                                <span className='open_tooltipa_head_prew'> ...
                                                    <div className='tooltipa_head_prew'>{metrics?.targets[1]?.target}</div>
                                                </span>
                                                
                                                </>
                                                :
                                                <></>
                                            }
                                        </div>  
                                    </div>
                                    <div className='contop_block_left_body_2_line_2'>
                                        <div className='contop_block_left_col_1'>
                                           
                                            {
                                                metrics?.targets[0]?.target.length>9?
                                                <></>
                                                :
                                                metrics?.targets[0]?.target
                                            }
                                            {   
                                                metrics?.targets[0]?.target.length>9?
                                                <>
                                                {metrics?.targets[0]?.target.substr(0, 8)}
                                                <span className='open_tooltipa_head_prew'> ...
                                                    <div className='tooltipa_head_prew'>{metrics?.targets[0]?.target}</div>
                                                </span>
                                                
                                                </>
                                                :
                                                <></>
                                            }
                                        </div>
                                        <div className='contop_block_left_col_2 vb1' style={
                                            metrics?.targets[1]?.confusionMatrix.tn>=0&&
                                            metrics?.targets[1]?.confusionMatrix.tn<(period)?
                                            {background:"rgba(218, 232, 253, 1)"}
                                            :
                                            metrics?.targets[1]?.confusionMatrix.tn>=(period)&&
                                            metrics?.targets[1]?.confusionMatrix.tn<(period*2)?
                                            {background:"rgba(193, 216, 252, 1)"}
                                            :
                                            metrics?.targets[1]?.confusionMatrix.tn>=(period*2)&&
                                            metrics?.targets[1]?.confusionMatrix.tn<(period*3)?
                                            {background:"rgba(169, 199, 251, 1)"}
                                            :
                                            metrics?.targets[1]?.confusionMatrix.tn>=(period*3)&&
                                            metrics?.targets[1]?.confusionMatrix.tn<(period*4)?
                                            {background:"rgba(149, 187, 249, 1)"}
                                            :
                                            {background:"rgba(121, 169, 248, 1)"}
                                        }>

                                            {metrics?.targets[1]?.confusionMatrix.tn}
                                        </div>
                                        
                                        <div className='contop_block_left_col_2 vb2' style={
                                            metrics?.targets[1]?.confusionMatrix.fp>=0&&
                                            metrics?.targets[1]?.confusionMatrix.fp<(period)?
                                            {background:"rgba(218, 232, 253, 1)"}
                                            :
                                            metrics?.targets[1]?.confusionMatrix.fp>=(period)&&
                                            metrics?.targets[1]?.confusionMatrix.fp<(period*2)?
                                            {background:"rgba(193, 216, 252, 1)"}
                                            :
                                            metrics?.targets[1]?.confusionMatrix.fp>=(period*2)&&
                                            metrics?.targets[1]?.confusionMatrix.fp<(period*3)?
                                            {background:"rgba(169, 199, 251, 1)"}
                                            :
                                            metrics?.targets[1]?.confusionMatrix.fp>=(period*3)&&
                                            metrics?.targets[1]?.confusionMatrix.fp<(period*4)?
                                            {background:"rgba(149, 187, 249, 1)"}
                                            :
                                            {background:"rgba(121, 169, 248, 1)"}
                                        }>
                                            {metrics?.targets[1]?.confusionMatrix.fn}
                                        </div>
                                    </div>
                                    <div className='contop_block_left_body_2_line_2'>
                                        <div className='contop_block_left_col_1'>
                                            {
                                                metrics?.targets[1]?.target.length>9?
                                                <></>
                                                :
                                                metrics?.targets[1]?.target
                                            }
                                            {   
                                                metrics?.targets[1]?.target.length>9?
                                                <>
                                                {metrics?.targets[1]?.target.substr(0, 8)}
                                                <span className='open_tooltipa_head_prew'> ...
                                                    <div className='tooltipa_head_prew'>{metrics?.targets[1]?.target}</div>
                                                </span>
                                                
                                                </>
                                                :
                                                <></>
                                            }
                                        </div>
                                        <div className='contop_block_left_col_3 vb3' style={
                                            metrics?.targets[1]?.confusionMatrix.fn>=0&&
                                            metrics?.targets[1]?.confusionMatrix.fn<(period)?
                                            {background:"rgba(218, 232, 253, 1)"}
                                            :
                                            metrics?.targets[1]?.confusionMatrix.fn>=(period)&&
                                            metrics?.targets[1]?.confusionMatrix.fn<(period*2)?
                                            {background:"rgba(193, 216, 252, 1)"}
                                            :
                                            metrics?.targets[1]?.confusionMatrix.fn>=(period*2)&&
                                            metrics?.targets[1]?.confusionMatrix.fn<(period*3)?
                                            {background:"rgba(169, 199, 251, 1)"}
                                            :
                                            metrics?.targets[1]?.confusionMatrix.fn>=(period*3)&&
                                            metrics?.targets[1]?.confusionMatrix.fn<(period*4)?
                                            {background:"rgba(149, 187, 249, 1)"}
                                            :
                                            {background:"rgba(121, 169, 248, 1)"}
                                        }>
                                            {metrics?.targets[1]?.confusionMatrix.fp}
                                        </div>
                                        <div className='contop_block_left_col_3 vb4' style={
                                            metrics?.targets[1]?.confusionMatrix.tp>=0&&
                                            metrics?.targets[1]?.confusionMatrix.tp<(period)?
                                            {background:"rgba(218, 232, 253, 1)"}
                                            :
                                            metrics?.targets[1]?.confusionMatrix.tp>=(period)&&
                                            metrics?.targets[1]?.confusionMatrix.tp<(period*2)?
                                            {background:"rgba(193, 216, 252, 1)"}
                                            :
                                            metrics?.targets[1]?.confusionMatrix.tp>=(period*2)&&
                                            metrics?.targets[1]?.confusionMatrix.tp<(period*3)?
                                            {background:"rgba(169, 199, 251, 1)"}
                                            :
                                            metrics?.targets[1]?.confusionMatrix.tp>=(period*3)&&
                                            metrics?.targets[1]?.confusionMatrix.tp<(period*4)?
                                            {background:"rgba(149, 187, 249, 1)"}
                                            :
                                            {background:"rgba(121, 169, 248, 1)"}
                                        }>
                                            {metrics?.targets[1]?.confusionMatrix.tp}
                                        </div>
                                    </div>
                                </div>
                                <div class="contop_block_left_body_2_line_bl new_line2" bis_skin_checked="1">
                                    <div class="contop_block_left_body_2_line_2" bis_skin_checked="1">
                                        <div class="contop_block_left_col_1" bis_skin_checked="1">Not selected</div>
                                        <div class="contop_block_left_col_2 vb1" bis_skin_checked="1" >{metrics?.unselected0 ?? 0}</div>
                                        <div class="contop_block_left_col_3 vb2" bis_skin_checked="1" >{metrics?.unselected1 ?? 0}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='contop_block_right'>
                        <div className='contop_block_title'>
                        {langv?.module_models?.contop?.text4}
                        </div>
                        <div className='contop_block_right_body'>
                            {/* <div className='contop_block_right_body_line_1'>
                                {
                                    Object.entries(topFieldsObj||[]).sort(([,a],[,b]) => a-b).reverse().slice(0,10).map(([key, value])=>
                                        <div className='contop_block_right_body_line'>
                                            {key}
                                        </div>
                                    )
                                }
                            </div>
                            <div className='contop_block_right_body_line_2 lintop_bl'>
                                {
                                    
                                    Object.entries(topFieldsObj||[]).sort(([,a],[,b]) => a-b).reverse().slice(0,10).map(([key, value])=>
                                        <div className='contop_block_right_body_line'>
                                            <div style={{width: value*coef+"%"}}></div>
                                            <span>{value.toFixed(2)}</span>
                                        </div>
                                    )
                                }
                            </div> */}
                            <Bar data={dataChart} options={optionsChart}/>
                        </div>
                    </div>
                </div>
                }
            
        </>
    )
})
export default Contop;